import { Badge } from "@/components/ui/badge";

interface Props {
  billingCycle: "monthly" | "yearly";
  setBillingCycle: (v: "monthly" | "yearly") => void;
  discount: number;
}

const BillingCycleToggle = ({ billingCycle, setBillingCycle, discount }: Props) => (
  <div className="flex justify-center">
    <div className="inline-flex items-center gap-1 rounded-full border p-1 bg-muted/30">
      <button
        onClick={() => setBillingCycle("monthly")}
        className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${billingCycle === "monthly" ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}
      >
        شهري
      </button>
      <button
        onClick={() => setBillingCycle("yearly")}
        className={`px-5 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-1.5 ${billingCycle === "yearly" ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}
      >
        سنوي
        <Badge variant="secondary" className="bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400 text-[10px] px-1.5">
          وفر {discount}%
        </Badge>
      </button>
    </div>
  </div>
);

export default BillingCycleToggle;
